import { Avatar, Box, HStack, Stack, Text } from '@chakra-ui/react';
import { RiAlarmWarningLine } from 'react-icons/ri';
import { Link } from 'react-router-dom';
import { useContext } from 'react';
import { UserProfileContext } from '../../context/userProfileContext';
import { NAV_ITEMS } from './navItems';
import { v4 as id } from 'uuid';
import CustomModal from '../CustomModal';
import NavEmergencyModal from './NavEmergencyModal';

const Sidebar = () => {
  const { userProfile } = useContext(UserProfileContext);
  // useEffect(() => {
  //   if (!isLoggedin) {
  //     navigate('/');
  //   }
  // }, []);

  return (
    <Stack
      bg='primary'
      minH='100%'
      borderBottomRightRadius='5px'
      color='#FFFFFF'
      pt='10'
    >
      <Box pl='20%'>
        <Avatar
          size='xl'
          name={userProfile?.tenantName}
          src={userProfile?.profilePicture}
        />
      </Box>
      <Text pl='20%' fontWeight='500' fontSize={'1.4rem'}>
        {userProfile?.tenantName}
      </Text>
      {/* <Text fontSize='x-small'>Estate ID: 1512852</Text> */}
      <Stack spacing='4' pl='20%' pt='2'>
        {NAV_ITEMS.map((navItem) => (
          <Link to={navItem.to} key={id()}>
            <HStack w='100%' cursor='pointer'>
              {navItem.icon}
              <Text fontSize='14px' pl='10px'>
                {navItem.title}
              </Text>
            </HStack>
          </Link>
        ))}

        <CustomModal
          overlayBG='primaryDark'
          size='xs'
          buttonProps={{ ...buttonProps }}
          btnTitle='Emergency'
          btnIcon={<RiAlarmWarningLine size={20} />}
        >
          <NavEmergencyModal />
        </CustomModal>
      </Stack>
    </Stack>
  );
};

export default Sidebar;

const buttonProps = {
  size: 'sm',
  bg: 'transparent',
  fontSize: '14px',
  fontWeight: 'light',
  w: '120px',
  pl: '0',
};
